export default __webpack_public_path__ + "images/research/icon-research-areas.png";